"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _InputMinMaxStyle = _interopRequireDefault(require("./InputMinMaxStyle"));
var _Types = require("../Types");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function InputMinMaxView(_ref) {
  var classes = _ref.classes,
    lowerBoundVal = _ref.lowerBoundVal,
    upperBoundVal = _ref.upperBoundVal,
    minLowerBound = _ref.minLowerBound,
    maxUpperBound = _ref.maxUpperBound,
    onInputChange = _ref.onInputChange,
    type = _ref.type;
  var handleInputChange = function handleInputChange(e) {
    var minMaxRange = [lowerBoundVal, upperBoundVal];
    if (type === _Types.silderTypes.INPUT_MIN) {
      minMaxRange[0] = Number(e.target.value);
    } else {
      minMaxRange[1] = Number(e.target.value);
    }
    onInputChange(minMaxRange);
  };
  var vlaue = type === _Types.silderTypes.INPUT_MIN ? lowerBoundVal : upperBoundVal;
  return /*#__PURE__*/_react.default.createElement(_core.Input, {
    value: vlaue,
    id: "slider_".concat(type),
    className: classes["slider_".concat(type)],
    onChange: function onChange(event) {
      return handleInputChange(event);
    },
    inputProps: {
      step: 1,
      min: minLowerBound,
      max: maxUpperBound,
      type: 'number'
    }
  });
}
var _default = (0, _styles.withStyles)(_InputMinMaxStyle.default)(InputMinMaxView);
exports.default = _default;